import Component from 'flarum/common/Component';
export default class UserEventCardComponents extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.cardClass = this.attrs.cardClass || "miniCard";
  }
  view() {
    const cardData = this.cardData = this.attrs.cardData || null;
    const cardUserData = this.cardData = this.attrs.cardUserData || null;
    if (cardData) {
      let cardName, cardStyle;
      if (cardData) {
        cardName = cardData.attribute("name");
        cardStyle = cardData.attribute("style") + ";margin-left:4px";
      }
      if (this.cardClass === "miniCard") {
        return m("span", {
          className: "EventCardItem miniCard",
          style: cardStyle
        }, cardName);
      } else {
        const cardName = cardData.attribute("name");
        const cardDesc = cardData.attribute("desc");
        const cardDays = cardData.attribute("days");
        const cardMode = cardData.attribute("mode");
        const cardValue = cardData.attribute("value");
        const cardNumber = cardUserData ? cardUserData.attribute("number") : "XXXX XXXX XXXX 1234";
        const cardStyle = cardData.attribute("style");
        const cardHolder = cardUserData ? cardUserData.attribute("name") : "XXX";
        const cardExpire = cardUserData ? cardUserData.attribute("expireAt") : "XX/XX";
        const cardRemain = cardUserData ? cardUserData.attribute("remain") : "XX";
        const forumImage = app.forum.attribute("logoUrl");
        let cardUsage = "";
        let cardUsageRemain = "";
        if (cardMode === 0) {
          cardUsage = app.translator.trans("ziven-community-core.forum.card-usage-value", {
            value: cardValue
          });
          cardUsageRemain = app.translator.trans("ziven-community-core.forum.card-usage-value", {
            value: cardRemain
          });
        } else {
          cardUsage = app.translator.trans("ziven-community-core.forum.card-usage-day", {
            value: cardDays
          });
          cardUsageRemain = app.translator.trans("ziven-community-core.forum.card-usage-day", {
            value: cardRemain
          });
        }
        return m("div", {
          className: "EventManageCard",
          style: cardStyle
        }, m("div", {
          className: "cardName"
        }, cardName), m("div", {
          className: "cardValue"
        }, cardUsage), m("div", {
          className: "cardNumber"
        }, cardNumber), m("div", {
          className: "cardHolderConatiner"
        }, m("div", {
          className: "cardHolderText"
        }, app.translator.trans('ziven-community-core.forum.card-holder')), m("div", {
          className: "cardHolder"
        }, cardHolder)), m("div", {
          className: "cardExpireConatiner"
        }, m("div", {
          className: "cardExpireText"
        }, app.translator.trans('ziven-community-core.forum.card-expire-date')), m("div", {
          className: "cardExpire"
        }, cardExpire)), m("div", {
          className: "cardRemainConatiner"
        }, m("div", {
          className: "cardRemainText"
        }, app.translator.trans('ziven-community-core.forum.card-usage-remain')), m("div", {
          className: "cardRemain"
        }, cardUsageRemain)), forumImage && m("div", {
          className: "cardLogo"
        }, m("img", {
          src: forumImage
        })));
      }
    }
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/components/UserEventCardComponents', UserEventCardComponents);